/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelogcharts_Byweekday2Inputs */

const id_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan berdasarkan Hari`)
};

const ms_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan mengikut Hari`)
};

const da_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringer efter Ugedag`)
};

const de_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen nach Wochentag`)
};

const en_us2_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes by Weekday`)
};

const es_es2_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios por día de la semana`)
};

const es_mx2_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios por día de la semana`)
};

const fil_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pagbabago ayon sa Araw ng Linggo`)
};

const fr_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications par jour`)
};

const it_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche per giorno della settimana`)
};

const hu_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változások a hét napjai szerint`)
};

const nl_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingen per weekdag`)
};

const no_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringer etter ukedag`)
};

const pl_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiany według dnia tygodnia`)
};

const pt_br2_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes by Weekday`)
};

const pt_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações por dia da semana`)
};

const ro_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificări după ziua săptămânii`)
};

const fi_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutokset viikonpäivittäin`)
};

const sv_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringar per veckodag`)
};

const vi_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi theo ngày trong tuần`)
};

const tr_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hafta Gününe Göre Değişiklikler`)
};

const cs_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změny podle dne v týdnu`)
};

const bg_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промени по ден от седмицата`)
};

const ru_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения по дням недели`)
};

const uk_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміни за днями тижня`)
};

const ar_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التغييرات حسب يوم الأسبوع`)
};

const hi_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सप्ताह के दिन के अनुसार परिवर्तन`)
};

const th_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลงตามวันในสัปดาห์`)
};

const ja_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曜日別の変更`)
};

const zh_cn2_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes by Weekday`)
};

const zh_hant1_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes by Weekday`)
};

const ko_components_changelogcharts_byweekday2 = /** @type {(inputs: Components_Changelogcharts_Byweekday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes by Weekday`)
};

/**
* | output |
* | --- |
* | "Changes by Weekday" |
*
* @param {Components_Changelogcharts_Byweekday2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelogcharts_byweekday2 = /** @type {((inputs?: Components_Changelogcharts_Byweekday2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelogcharts_Byweekday2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelogcharts_byweekday2(inputs)
	if (locale === "ms") return ms_components_changelogcharts_byweekday2(inputs)
	if (locale === "da") return da_components_changelogcharts_byweekday2(inputs)
	if (locale === "de") return de_components_changelogcharts_byweekday2(inputs)
	if (locale === "en-US") return en_us2_components_changelogcharts_byweekday2(inputs)
	if (locale === "es-ES") return es_es2_components_changelogcharts_byweekday2(inputs)
	if (locale === "es-MX") return es_mx2_components_changelogcharts_byweekday2(inputs)
	if (locale === "fil") return fil_components_changelogcharts_byweekday2(inputs)
	if (locale === "fr") return fr_components_changelogcharts_byweekday2(inputs)
	if (locale === "it") return it_components_changelogcharts_byweekday2(inputs)
	if (locale === "hu") return hu_components_changelogcharts_byweekday2(inputs)
	if (locale === "nl") return nl_components_changelogcharts_byweekday2(inputs)
	if (locale === "no") return no_components_changelogcharts_byweekday2(inputs)
	if (locale === "pl") return pl_components_changelogcharts_byweekday2(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelogcharts_byweekday2(inputs)
	if (locale === "pt") return pt_components_changelogcharts_byweekday2(inputs)
	if (locale === "ro") return ro_components_changelogcharts_byweekday2(inputs)
	if (locale === "fi") return fi_components_changelogcharts_byweekday2(inputs)
	if (locale === "sv") return sv_components_changelogcharts_byweekday2(inputs)
	if (locale === "vi") return vi_components_changelogcharts_byweekday2(inputs)
	if (locale === "tr") return tr_components_changelogcharts_byweekday2(inputs)
	if (locale === "cs") return cs_components_changelogcharts_byweekday2(inputs)
	if (locale === "bg") return bg_components_changelogcharts_byweekday2(inputs)
	if (locale === "ru") return ru_components_changelogcharts_byweekday2(inputs)
	if (locale === "uk") return uk_components_changelogcharts_byweekday2(inputs)
	if (locale === "ar") return ar_components_changelogcharts_byweekday2(inputs)
	if (locale === "hi") return hi_components_changelogcharts_byweekday2(inputs)
	if (locale === "th") return th_components_changelogcharts_byweekday2(inputs)
	if (locale === "ja") return ja_components_changelogcharts_byweekday2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelogcharts_byweekday2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelogcharts_byweekday2(inputs)
	return ko_components_changelogcharts_byweekday2(inputs)
});
export { components_changelogcharts_byweekday2 as "components.changelogCharts.byWeekday" }